import { ContainerProps } from '../../interfaces/container.interface'
import { ClientTypes } from '../../utilities/constants'
import c from 'classnames'
import styles from './Section.module.scss'

interface Props extends ContainerProps {
    client: ClientTypes
}

const SectionComponent = ({ client, children }: Props) => {
    return (
        <section className={c(
            styles.content,
            client === 'street' ? styles.street : styles.places,
        )}>
            {children}
        </section>
    )
}

export default SectionComponent
